import { React, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  makeStyles,
  Button,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useTranslate } from "react-admin";

import CustomToggleButtons from "./component/CustomToggleButtons";
//import transitions from "@material-ui/core/styles/transitions";
const useStyles = makeStyles((theme) => ({
  containerWithFlex: {
    width: "100%",
    display: "grid",
    alignItems: "center",
    gridTemplateColumns: "150px auto",
  },
  textWithFlexAndMargin: {
    margin: "20px 0 20px 5px ",
  },
  container: {
    margin: "0 20px 20px 0",
    boxShadow: " 0px 2px 5px rgba(0, 0, 0, 0.15)",
    borderRadius: 12,
    backgroundColor: theme.lightGray,
  },
  textButtonStyle: {
    fontWeight: 600,
    fontSize: 20,
    color: theme.pureWhite,
  },
  buttonCancle: {
    height: 50,
    borderRadius: 0,
    borderBottomLeftRadius: 12,
    width: "100%",
    backgroundColor: theme.darkGray2,
    "&:hover": {
      backgroundColor: theme.darkGray2,
    },
  },
  buttonSave: {
    height: 50,
    borderRadius: 0,
    borderBottomRightRadius: 12,
    width: "100%",
    backgroundColor: theme.blue,
    "&:hover": {
      backgroundColor: theme.blue,
    },
  },
  autocomplete: {
    justifySelf: "start",
    borderRadius: 8,
  },
  textfield: {
    margin: "0px auto",
    width: 190,
    borderRadius: 8,
    [`& fieldset`]: {
      borderRadius: 8,
    },
  },
}));

let autoCompleteOption = [{ id: 1, name: "Teacher" }];
function EditSecondPersonalInformation({
  userProfileData,
  onSave,
  onCancel,
  occupations,
  currentOccupation,
}) {
  const classes = useStyles();
  const [selectedNationality, setSelectedNationality] = useState(
    userProfileData.nationality
  );
  const translate = useTranslate();

  const genderToggleButtonLists = [
    {
      id: 1,
      name: translate("ra.text.Male"),
      value: "Male",
    },
    {
      id: 2,
      name: translate("ra.text.Female"),
      value: "Female",
    },
    {
      id: 3,
      name: translate("ra.text.other"),
      value: "Other",
    },
  ];

  const statusToggleButtonLists = [
    {
      id: 1,
      name: translate("ra.text.single"),
    },
    {
      id: 2,
      name: translate("ra.text.married"),
    },
    {
      id: 3,
      name: translate("ra.text.other"),
    },
  ];

  const [nationality, setNationality] = useState(userProfileData.nationality);
  const [selectedGender, setSelectedGender] = useState(userProfileData.gender);
  const [selectedStatus, setSelectedStatus] = useState(userProfileData.status);
  const [selectedOccupation, setSelectedOccupation] =
    useState(currentOccupation);
  autoCompleteOption = occupations;
  const handleCustomToggleValue = (newValue, index) => {
    if (index === 1) {
      if (selectedNationality === newValue) {
        setSelectedNationality(selectedNationality);
      } else {
        setSelectedNationality(newValue);
      }
    } else if (index === 2) {
      if (selectedGender === newValue) {
        setSelectedGender(selectedGender);
      } else {
        setSelectedGender(newValue);
      }
    } else {
      if (selectedStatus === newValue) {
        setSelectedStatus(selectedStatus);
      } else {
        setSelectedStatus(newValue);
      }
    }
  };

  return (
    <Box className={classes.container}>
      <Box margin="20px">
        <Box className={classes.containerWithFlex}>
          <Typography className={classes.textWithFlexAndMargin}>
            {translate("ra.text.ci.generalInformation.nationality")}
          </Typography>
          <TextField
            value={nationality}
            variant="outlined"
            onChange={(e) => setNationality(e.target.value)}
          />
        </Box>

        <Box display="flex">
          <Box className={classes.containerWithFlex}>
            <Typography className={classes.textWithFlexAndMargin}>
              {translate("ra.text.ci.generalInformation.gender")}
            </Typography>
            {/* <Box width="20px" /> */}
            <Box flex="5">
              {genderToggleButtonLists.map((element, index) => {
                return (
                  <CustomToggleButtons
                    nameOfButton={element.name}
                    key={index}
                    value={element.name}
                    selected={selectedGender === element.value}
                    onClick={() => {
                      handleCustomToggleValue(element.value, 2);
                    }}
                  />
                );
              })}
            </Box>
          </Box>
        </Box>
        <Box display="flex">
          <Box className={classes.containerWithFlex}>
            <Typography className={classes.textWithFlexAndMargin}>
              {translate("ra.text.ci.generalInformation.status")}
            </Typography>

            <Box flex="5">
              {statusToggleButtonLists.map((element, index) => {
                return (
                  <CustomToggleButtons
                    nameOfButton={element.name}
                    key={index}
                    value={element.name}
                    selected={
                      selectedStatus?.toLowerCase() ===
                      element.name.toLowerCase()
                    }
                    onClick={() => {
                      handleCustomToggleValue(element.name, 3);
                    }}
                  />
                );
              })}
            </Box>
          </Box>
        </Box>
        <Box display="flex">
          <Box className={classes.containerWithFlex}>
            <Typography className={classes.textWithFlexAndMargin}>
              {translate("ra.text.ci.generalInformation.occupation")}
            </Typography>

            <Autocomplete
              classes={{ root: classes.autocomplete }}
              options={autoCompleteOption}
              getOptionLabel={(option) => {
                if (option.hasOwnProperty("name")) {
                  return option.name;
                }
                return option;
              }}
              getOptionSelected={(option) => {
                if (option.hasOwnProperty("name")) {
                  return option.name;
                }
                return option;
              }}
              value={selectedOccupation?.name}
              onChange={(_, newInputValue) => {
                setSelectedOccupation(newInputValue);
              }}
              renderInput={(params) => (
                <TextField
                  variant="outlined"
                  // underlineShow={false}
                  classes={{ root: classes.textfield }}
                  placeholder="Enter Occupation"
                  {...params}
                />
              )}
            />
          </Box>
        </Box>
      </Box>

      <Box display="flex" justifyContent="center">
        <Button className={classes.buttonCancle} onClick={onCancel}>
          <Typography className={classes.textButtonStyle}>
            {translate("ra.action.cancel")}
          </Typography>
        </Button>
        <Button
          className={classes.buttonSave}
          onClick={() =>
            onSave({
              nationality,
              gender: selectedGender,
              state: selectedStatus,
              occupation_id: selectedOccupation?.id ?? null,
            })
          }
        >
          <Typography className={classes.textButtonStyle}>
            {translate("ra.action.save")}
          </Typography>
        </Button>
      </Box>
    </Box>
  );
}

export default EditSecondPersonalInformation;
